import { OPEN_TTL_MS, openDocId, utcDayNumber } from '@talkofthetown/shared';
import type { User } from 'firebase/auth';
import { doc, serverTimestamp, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

const KEY = 'tott.opened';

function openedToday(): { day: number; ids: string[] } {
  const day = utcDayNumber(Date.now());
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? 'null') as {
      day: number;
      ids: string[];
    } | null;
    if (v && v.day === day && Array.isArray(v.ids)) return v;
  } catch {
    /* ignore */
  }
  return { day, ids: [] };
}

/**
 * Records that this viewer opened a post: one small write, validated by security rules (no function
 * call). Counted at most once per post per day; repeats are skipped locally and rejected by rules.
 */
export async function recordOpen(postId: string, user: User | null): Promise<void> {
  if (!user) return;
  const now = Date.now();
  const id = openDocId(postId, user.uid, now);
  const seen = openedToday();
  if (seen.ids.includes(id)) return;
  try {
    await setDoc(doc(db, 'opens', id), {
      postId,
      uid: user.uid,
      anon: user.isAnonymous,
      at: serverTimestamp(),
      expireAt: Timestamp.fromMillis(now + OPEN_TTL_MS),
    });
  } catch {
    // Already counted today (or the post went away): nothing to do.
  }
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ day: seen.day, ids: [...seen.ids.slice(-500), id] }),
    );
  } catch {
    /* ignore */
  }
}
